import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Hero.module.css';

export default function Hero() {
  return (
    <section className={styles.hero}>
      <div className={styles.grid} />
      <div className={styles.glow} />
      <div className={styles.glow2} />

      <div className={styles.content}>
        <div className={styles.badge}>
          <span className={styles.dot} />
          Full-Stack Digital Agency — Modern Solutions
        </div>

        <h1 className={styles.heading}>
          We Build<br />
          <em>Digital Growth</em>
          <span className={styles.outline}>Systems</span>
        </h1>

        <p className={styles.desc}>
          When systems break or businesses struggle, 404 Stack delivers the complete technology stack and marketing strategy to rebuild and grow stronger.
        </p>

        <div className={styles.actions}>
          <a href="#services" className="btn-primary" onClick={e => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); }}>
            Explore Services
          </a>
          <Link to="/contact" className="btn-ghost">Start a Project →</Link>
        </div>

        <div className={styles.stats}>
          <div className={styles.stat}>
            <span className={styles.num}>8<em>+</em></span>
            <span className={styles.label}>Core Services</span>
          </div>
          <div className={styles.stat}>
            <span className={styles.num}>100<em>%</em></span>
            <span className={styles.label}>Client Focus</span>
          </div>
          <div className={styles.stat}>
            <span className={styles.num}>6</span>
            <span className={styles.label}>Industries Served</span>
          </div>
        </div>
      </div>
    </section>
  );
}
